<template>
  <div
    v-if="!noAccount"
    class="dropdown-wrapper"
    :class="{
      mobile: isMobile,
      contextWrapped: isContextWrapped,
      'single-dropdown': isContextSelectorOfASHidden
    }"
  >
    <div
      class="dropdown-box-wrapper"
      :class="{
        'single-box': noASN,
        isExpanded:
          this.selectedComboBox === selectedComboBoxType.MEMBER_ACCOUNT,
        isCollapsed: this.selectedComboBox === selectedComboBoxType.ASN_CONTEXT
      }"
    >
      <div class="dropdown-label">Member account:</div>
      <Dropdown
        @on-select="onSelectAccount"
        :selected="selectedAccount"
        :list="parsedAccountList"
        placeholder="Type member account"
        :disabled="noAccount"
      ></Dropdown>
    </div>
    <div
      v-if="!isContextSelectorOfASHidden"
      class="dropdown-box-wrapper"
      :class="{
        isExpanded: this.selectedComboBox === selectedComboBoxType.ASN_CONTEXT,
        isCollapsed:
          this.selectedComboBox === selectedComboBoxType.MEMBER_ACCOUNT
      }"
    >
      <div class="dropdown-label">Showing routes for:</div>
      <Dropdown
        @on-select="onSelectASN"
        :selected="selectedASN"
        :list="parsedASNList"
        placeholder="Type origin AS"
      ></Dropdown>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

import mixin from '../../utils/mixin';
import Dropdown from '../ui/Dropdown.vue';
import { ID_OF_MY_PREFIXES_CONTEXT } from '../../constants/routingStatusConstant';
import { SELECTED_COMBO_BOX_TYPE } from '../../constants/common';

export default {
  name: 'ContextSelectorWithPrefix',

  components: { Dropdown },

  mixins: [mixin],

  data() {
    return {
      selectedComboBoxType: SELECTED_COMBO_BOX_TYPE,
      isContextSelectorOfASHidden: false
    };
  },

  computed: {
    ...mapState(['selectedComboBox']),
    ...mapGetters('dataStore', ['noAccount', 'noASN']),

    selectedAccount() {
      return this.$store.getters['dataStore/selectedAccount']
        ? this.$store.getters['dataStore/selectedAccount'].id
        : '';
    },

    selectedASN() {
      return this.$store.getters['dataStore/selectedASN']
        ? this.$store.getters['dataStore/selectedASN'].id
        : '';
    },

    parsedAccountList() {
      return this.accountList.map(i => ({
        ...i,
        label: i.account
      }));
    },

    parsedASNList() {
      const list = this.asnList
        ? this.asnList.map(i => ({
            ...i,
            label: `AS${i.id}  | ${i.asn}`
          }))
        : [];

      list.unshift({ id: ID_OF_MY_PREFIXES_CONTEXT, label: 'your prefixes' });

      return list;
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        if (['/alerts-routing-status'].includes(to.path)) {
          this.isContextSelectorOfASHidden = true;
        } else {
          this.isContextSelectorOfASHidden = false;
        }
      }
    }
  },

  methods: {
    ...mapActions('routingStatusStore', ['fetchRoutingStatusDataOfPrefixes']),
    onSelectAccount(id) {
      this.selectAccount('' + id);
    },

    onSelectASN(id) {
      if (id === ID_OF_MY_PREFIXES_CONTEXT) {
        this.fetchRoutingStatusDataOfPrefixes();
      } else {
        this.selectASN('' + id);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.dropdown-wrapper {
  display: flex;
  justify-content: space-between;
  width: 27rem;
  align-items: center;

  &.single-dropdown {
    width: 13rem;
  }

  a {
    color: $text-black;
  }
}

.dropdown-box-wrapper {
  display: flex;
  flex-direction: column;

  &.single-box {
    margin-right: auto;
  }

  /deep/ .dash-dropdown {
    background-color: $background-white;
    border: 1px solid $icon-grey;

    &__input input {
      background-color: $background-white;
      color: $text-black;
      width: 100%;
    }
  }
}

.dropdown-label {
  position: relative;
  top: 0.4rem;
  left: 0.5rem;
  z-index: 10;
  display: inline-block;
  max-width: 7.5rem;
  font-size: 12px;
  color: $text-black;
  background-color: $background-white;
  margin: 0;
  line-height: 1em;
  padding-bottom: 5px;

  @include single-line-ellipsis;
}

.mobile {
  &.dropdown-wrapper {
    width: 100%;
    justify-content: space-between;
  }

  &.dropdown-wrapper.single-dropdown {
    justify-content: flex-end;
  }

  .dropdown-box-wrapper {
    width: 50%;
    padding-right: 1rem;
    transition: width 0.3s;

    &.single-box {
      margin-left: 0;
    }

    &.isExpanded {
      width: 80%;
    }

    &.isCollapsed {
      width: 20%;
    }
  }

  /deep/ .dash-dropdown {
    width: 100%;

    .dash-dropdown__label {
      width: calc(100% - 1rem);
    }
  }
}

.contextWrapped {
  padding-top: 1rem;

  .dropdown-wrapper {
    flex-wrap: wrap;
    width: 14rem;
  }

  .dropdown-label {
    z-index: 2;
  }
}
</style>
